import React, { ReactElement } from 'react';

import styles from './FaceFilterComponent.css';

export const TipContent = (): ReactElement => (
    <div className={styles.tip}>
        <div className={styles.header}>Люди на фото</div>
        <div className={styles.description}>Теперь вы можете фильтровать фото по распознанным лицам в альбоме</div>
    </div>
);
